import { html, repeat, ref, when } from '@microsoft/fast-element';
import { checklistIcon, keyIcon, supportIcon, userEditIcon, whiteCheckIcon } from '../../../styles';
import type { UserModal } from './user-modal';
import { sync } from '@genesislcap/foundation-utils';

export const UserModalTemplate = html<UserModal>`
  <right-side-modal
    classes="user-modal"
    :show="${(x) => x.show}"
    @modalClosing=${(x) => x.closeModal()}
    width="${(x) => x.width}"
    header="${(x) => x.title}"
    buttons="false"
    closeModalHeader="${(x) => x.closeModal()}"
    closeModalDescription="${(x) => x.closeModal()}"
  >
    <div class="user-modal-rectangle">
      <div>
        <span class="user-modal-username">${(x) => x.username}</span>
      </div>
      <div class="user-modal-roles">
        <span>${(x) => x.profiles}</span>
      </div>
    </div>
    <div class="user-modal-menu">
      <div class="user-modal-menu-item">
        <label class="zero-select-label">Current Company:</label>
        <zero-select
          ${ref('userCompanyElement')}
          :value=${sync((x) => x.currentCompanyId)}
          class="input-control"
          @change="${(x) => x.companySelected()}"
        >
          ${repeat(
            (x) => x.userCompanies,
            html`
              <zero-option value="${(x) => x.CASCADE_COMPANY_ID}">
                ${(x) => x.CASCADE_COMPANY_NAME}
              </zero-option>
            `,
          )}
        </zero-select>
      </div>
      <div
        class="user-modal-menu-item"
        style="${(x) => (!x.userService.hasBuyerAndSellerVisibility() ? 'display: none' : '')}"
      >
        <label class="zero-select-label">Current Side:</label>
        <zero-select
          ${ref('currentSideElement')}
          :value=${sync((x) => x.currentSide)}
          class="input-control"
          @change="${(x) => x.sideSelected()}"
        >
          <zero-option value="SELLER">Seller</zero-option>
          <zero-option value="BUYER">Buyer</zero-option>
        </zero-select>
      </div>
      ${when(
        (x) => x.isAdvisor,
        html<UserModal>`
          <div class="user-modal-menu-item hyperlink">
            <span>${checklistIcon('start')}</span>
            <span @click="${(x) => x.openCompanyModal()}">Manage Company</span>
          </div>
        `,
      )}
      ${when(
        (x) => x.isAdvisor && x.companyService.getCurrentCompany().AUTO_EXECUTION_FLAG,
        html<UserModal>`
          <div class="user-modal-menu-item hyperlink">
            <span>${whiteCheckIcon('start')}</span>
            <span @click="${(x) => (x.autoExecuteApprovedCounterpartiesModal = true)}">
              Auto-Execute Approved Counterparties
            </span>
          </div>
        `,
      )}
      <div class="user-modal-menu-item hyperlink">
        <a href="mailto:markets@resurety.com">
          <span>${supportIcon('start')}</span>
          <span>Contact Support</span>
        </a>
      </div>
    </div>
    <zero-tabs class="footer">
      <tab-buttons slot="end">
        <zero-button slot="buttons" appearance="tab-primary" @click="${(x) => x.logout()}">
          Logout
        </zero-button>
      </tab-buttons>
    </zero-tabs>
    ${when(
      (x) => x.autoExecuteApprovedCounterpartiesModal,
      html<UserModal>`
        <auto-execute-approved-counterparties-modal
          @close="${(x) => (x.autoExecuteApprovedCounterpartiesModal = false)}"
        ></auto-execute-approved-counterparties-modal>
      `,
    )}
  </right-side-modal>

  <zero-modal
    ${ref('editEntityModal')}
    position="centre"
    :onCloseCallback=${(x) => x.closeCompanyModal.bind(x)}
    data-test-id="edit-entity-modal"
  >
    ${when(
      (x) => x.editModalVisible,
      html<UserModal>`
        <edit-company ${ref('editCompanyModal')} :isEditable=${(x) => x.isEditable}></edit-company>
      `,
    )}
  </zero-modal>
`;
